// @core/api/endpoints/payment/register_payment_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentTypeDefinitionResponse,
  RegisterPaymentTypeRequest,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Register payment type
 * Registers a new payment type. Products call this on startup to declare their payable entity types (booking.session_payment, property.rent_payment, etc.). PaymentService then manages payment lifecycle for any entity with payment aspect of this type.
 */
export async function RegisterPaymentType(
  data: RegisterPaymentTypeRequest,
  options?: RequestOptions
): Promise<PaymentTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-types`;
  const requestOptions = options;
  return client.post<PaymentTypeDefinitionResponse>(requestPath, data, requestOptions);
}
